import { useState } from 'react';
import { Entry } from '../types';
import { extractFilesFromEntry } from '../create-entry/CreateEntryPageV1_5';
import { submitFiles } from './submitFiles';
import { makeRequest } from './makeRequest';

export type UpdateDataEntryResult = {
	httpStatusCode: number;
	updatedEntry: Entry;
	newDatasetentryid: string;
};

export const useUpdateDataEntryMutation = () => {
	const [data, setData] = useState<{ updatedEntry: Entry }>();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error>();

	async function mutate({
		projectId,
		entryId,
		entry,
		setName
	}: {
		projectId: string;
		entryId: string;
		entry: Entry;
		setName?: string;
	}) {
		setLoading(true);

		try {
			const { entryWithoutFiles, files } = extractFilesFromEntry({
				entry
			});

			const result: UpdateDataEntryResult = await makeRequest({
				method: 'updateDataEntry',
				service: 'cde',
				data: {
					projectId,
					datasetentryid: entryId,
					observationData: entryWithoutFiles,

					...(setName ? { set: { setName } } : {})
				}
			});

			if (files.length > 0) {
				await submitFiles({
					entryId: result.newDatasetentryid,
					files,
					projectId,
					setName
				});
			}

			setData(result); // this is missing the updated values for the files
			return result;
		} catch (e) {
			setError(e as Error);

			throw e;
		} finally {
			setLoading(false);
		}
	}

	return {
		data,
		loading,
		error,
		mutate,
		reset: () => {
			setData(undefined);
			setError(undefined);
			setLoading(false);
		}
	};
};
